export function shouldUseNativeMobileRecordingUi({ isMobile, isMobileApp, isChromeExtension, isChiro, pathname = "" }) {
  return Boolean(isMobile && isMobileApp && !isChromeExtension && !isChiro && pathname.startsWith("/chat/"));
}
